/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {
    scheduledQuestionnaireInstancesGet,
    ScheduledQuestionnaireInstancesGetParams
} from "../fn/scheduled-questionnaire/scheduled-questionnaire-instances-get";
import {ScheduledQuestionnaireInstanceModel} from "../models/scheduled-questionnaire-instance-model";
import {PaginatedList} from "../models/paginator/paginated-list";
import {
    scheduledQuestionnaireInstancePost,
    ScheduledQuestionnaireInstancesPostParams
} from "../fn/scheduled-questionnaire/scheduled-questionnaire-instances-post";

@Injectable({ providedIn: 'root' })
export class ScheduledQuestionnaireService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Gets scheduled questionnaire instances for an account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `inviteLinksGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    scheduledQuestionnairesGet$Response(headers: HttpHeaders, params: ScheduledQuestionnaireInstancesGetParams, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<ScheduledQuestionnaireInstanceModel>>> {
        return scheduledQuestionnaireInstancesGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets scheduled questionnaire instances for an account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `inviteLinksGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    scheduledQuestionnairesGet(headers: HttpHeaders, params: ScheduledQuestionnaireInstancesGetParams, context?: HttpContext): Observable<PaginatedList<ScheduledQuestionnaireInstanceModel>> {
        return this.scheduledQuestionnairesGet$Response(headers, params, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<ScheduledQuestionnaireInstanceModel>>): PaginatedList<ScheduledQuestionnaireInstanceModel> => r.body)
        );
    }

    /**
     * Adds a scheduled questionnaire instance
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    scheduledQuestionnairesPost(headers: HttpHeaders, params: ScheduledQuestionnaireInstancesPostParams, context?: HttpContext): Observable<void> {
        return scheduledQuestionnaireInstancePost(this.http, this.rootUrl, params, headers, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body)
        );
    }
}
